export const codigos = [
  {
    id: 1,
    codigo: 1,
  },
  {
    id: 2,
    codigo: 2,
  },
  {
    id: 3,
    codigo: 3,
  },
  {
    id: 4,
    codigo: 4,
  },
  {
    id: 5,
    codigo: 5,
  },
  {
    id: 6,
    codigo: 6,
  },
  {
    id: 7,
    codigo: 7,
  },
  {
    id: 8,
    codigo: 8,
  },
  {
    id: 9,
    codigo: 9,
  },
  {
    id: 10,
    codigo: 10,
  },
  {
    id: 11,
    codigo: 11,
  },
  {
    id: 12,
    codigo: 12,
  },
  {
    id: 13,
    codigo: 13,
  },
  {
    id: 14,
    codigo: 14,
  },
  {
    id: 15,
    codigo: 15,
  },
  {
    id: 16,
    codigo: 16,
  },
  {
    id: 17,
    codigo: 17,
  },
  {
    id: 18,
    codigo: 18,
  },
  {
    id: 19,
    codigo: 19,
  },
  {
    id: 20,
    codigo: 20,
  },
  {
    id: 21,
    codigo: 21,
  },
  {
    id: 22,
    codigo: 22,
  },
  {
    id: 23,
    codigo: 23,
  },
  {
    id: 24,
    codigo: 24,
  },
  {
    id: 25,
    codigo: 25,
  },
  {
    id: 26,
    codigo: 26,
  },
  {
    id: 27,
    codigo: 27,
  },
  {
    id: 28,
    codigo: 28,
  },
  {
    id: 29,
    codigo: 29,
  },
  {
    id: 30,
    codigo: 30,
  },
];

const tipoConta = [
  {
    id: 'CORRENTE',
    descricao: 'Corrente',
  },
  {
    id: 'POUPANCA',
    descricao: 'Poupança',
  },
];

const SLOGAN_AGROGER = 'Agroger - O software do cafeicultor';

const PRODUTO_CAFE_ID = 100;
const PRODUTO_GOIABA_ID = 103;
const PRODUTO_APPLE_ID = 106;
const PRODUCT_CAFE_ID = 1;

export {
  tipoConta,
  SLOGAN_AGROGER,
  PRODUTO_CAFE_ID,
  PRODUCT_CAFE_ID,
  PRODUTO_GOIABA_ID,
  PRODUTO_APPLE_ID,
};
